
// Update a single field
export const updateField = (field, value) => {
	return {
		type: 'UPDATE_FIELD',
		field,
		value
	}
}

// Update mutliple fields
export const updateFields = (fields) => {
	return {
		type: 'UPDATE_FIELDS',
		fields
	}
}

// Clear multiple fields
export const clearFields = (fieldNames) => {
	return {
		type: 'CLEAR_FIELDS',
		fieldNames
	}
}


export default {
	updateField,
	updateFields,
	clearFields,
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/fields/fields-actions.ts